import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { getDataForTaskRequestApprovalAsync, setDateRangeValue, ApproveSelectedAsync, SingleApproveOrRejectAsync } from '../../taskrequesthours/taskRequestHoursSlice';
import OffCanvas from '../../../common/OffCanvas';
import { useTranslation } from "react-i18next";
import Select, { StylesConfig } from 'react-select';
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import CustomPagination from "../../../common/Pagination";
import { getPageSizeArray, getFilteredList, paginationStyles, getValueFromResource } from "../../../common/timeLiveFunction";
import { ShowSwalWithConfirmationMessage } from "../../../common/SweetAlert";
import moment from "moment";
import { ShowToast } from "../../../common/Toastr";
import TaskRequestApprovalFilter from "./TaskRequestApprovalFilter";
import TaskRequestApprovalItem from "./TaskRequestApprovalItem";
import Loader from '../../../common/Loader';

const TaskRequestApproval = () => {
    const { t } = useTranslation();
    const generalObject = {
        "name": t('Filters'),
        "width": "500px",
        "componentName": <TaskRequestApprovalFilter t={t} />
    }
    const { taskRequestApprovalList, accountprojecttaskid, TaskIdForApproval, isReload, selectedRecord, isLoading, startDate, endDate } = useAppSelector((state) => state.taskRequestHours);
    const { pageId, menuList, IsEdit, sessionAccountEmployeeId, maxMenuHeight } = useAppSelector((state) => state.globalState);

    const modalAttachmentRef = useRef<any>(null);
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        if (isReload) {
            //const StartDate = moment(startDate).subtract(2, 'months').format('MM-DD-YYYY')
            //const EndDate = moment(endDate).format('MM-DD-YYYY');
            const StartDate = moment(startDate).subtract(2, 'months').format('YYYY-MM-DD')            
            const EndDate = moment(endDate).format('YYYY-MM-DD')
            dispatch(getDataForTaskRequestApprovalAsync({ StartDate: StartDate, EndDate: EndDate, AccountProjectTaskId: TaskIdForApproval }));
        }
    }, [isReload]);

    useEffect(() => {
        //const StartDate = moment(startDate).subtract(2, 'months').format('MM-DD-YYYY')
        //const EndDate = moment(endDate).format('MM-DD-YYYY');
        const StartDate = moment(startDate).subtract(2, 'months').format('YYYY-MM-DD')   
        const EndDate = moment(endDate).format('YYYY-MM-DD')         
        dispatch(getDataForTaskRequestApprovalAsync({ StartDate: StartDate, EndDate: EndDate, AccountProjectTaskId: TaskIdForApproval }));
    }, [dispatch]);

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };

    const filteredData: any = getFilteredList(taskRequestApprovalList, searchTerm);

    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = taskRequestApprovalList.length;
    const recordsFiltered = filteredData.length;

    const handleApprovedOrRejectedClick = (e: any) => {
        e.preventDefault();
        const id = e.target.id;
        ShowSwalWithConfirmationMessage(`Are you sure you want to ${id} this record?`, "", `Yes, Proceed`)
            .then((result) => {
                if (result) {
                    dispatch(ApproveSelectedAsync({ List: taskRequestApprovalList, id: id }))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast(`${id === "Approve" ? "Approved" : "Rejected"} Successfully`, 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('Task Request Approvals')} */}
                        {getValueFromResource('Task Request Approvals',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        {(taskRequestApprovalList.length > 0) ? (
                            <div className='h-35px w-1px mx-1'></div>
                        ) : null}
                        {(taskRequestApprovalList.length > 0) ? (
                            <div className="d-flex align-items-center">
                                <Select
                                    styles={paginationStyles}
                                    maxMenuHeight={maxMenuHeight}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'

                                />
                            </div>
                        ) : null}
                        {(taskRequestApprovalList.length > 0) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null}
                        <div>
                            {(taskRequestApprovalList.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                    recordsFiltered={recordsFiltered}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <a id="kt_OffCanvas"
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content=
                            // {t("Filters")}
                            {getValueFromResource('Filters',dispatch, t)}
                            data-tooltip-place="bottom">
                            <i className="bi bi-filter fs-3 iconColor"></i>
                        </a>
                        {IsEdit ? (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <button
                                    type="button"
                                    id="Approve"
                                    style={{ marginRight: '2px', display: taskRequestApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                    className={`btn btn-sm btn-outline me-2 mb-0 btn-active-light-success text-success fs-7`}
                                    onClick={(e: any) => handleApprovedOrRejectedClick(e)}

                                >
                                    {/* {t('Approve Selected')} */}
                                    {getValueFromResource('Approve Selected',dispatch, t)}
                                </button>
                                {/* <div className='bullet bg-secondary h-35px w-1px mx-3' style={{ marginRight: '2px', display: taskRequestApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}></div> */}
                                <button
                                    type="button"
                                    id="Reject"
                                    className={`btn btn-sm btn-outline me-0 mb-0 btn-active-light-danger text-danger fs-7`}
                                    onClick={(e: any) => handleApprovedOrRejectedClick(e)}
                                    style={{ marginRight: '2px', display: taskRequestApprovalList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    {/* {t('Reject Selected')} */}
                                    {getValueFromResource('Reject Selected',dispatch, t)}
                                </button>
                            </>
                        ) : null}
                    </div>
                </div>
                <div className="card-body" >
                    <div className="table-responsive">
                        <TaskRequestApprovalItem taskRequestApprovalList={taskRequestApprovalList} t={t} IsEdit={IsEdit} />
                    </div>
                </div>
            </div>
            <OffCanvas obj={generalObject} />
        </>
    )
}

export default TaskRequestApproval;